import React from "react";
import { RADAR_BLIP_POSITIONS } from "./radarData";

// Radar circular con barrido de luz + pings de datos — panel derecho de
// "La Brújula" (versión alternativa al carrusel 3D, ver
// design_handoff_sustemia_login/README.md).
export function EcoRadar({ blips }) {
  return (
    <div className="eco-radar">
      <span className="eco-radar__ring eco-radar__ring--1" />
      <span className="eco-radar__ring eco-radar__ring--2" />
      <span className="eco-radar__ring eco-radar__ring--3 eco-radar__ring--dashed" />
      <span className="eco-radar__ring eco-radar__ring--4" />
      <span className="eco-radar__crosshair eco-radar__crosshair--h" />
      <span className="eco-radar__crosshair eco-radar__crosshair--v" />
      <span className="eco-radar__beam" />
      <span className="eco-radar__center" />

      {blips.map((blip, i) => {
        const pos = RADAR_BLIP_POSITIONS[i % RADAR_BLIP_POSITIONS.length];
        return (
          <div
            key={i}
            className="eco-radar__blip"
            style={{ left: pos.left, top: pos.top }}
          >
            <span className="eco-radar__blip-dot" style={{ animationDelay: pos.delay }} />
            <span className="eco-radar__blip-text">
              <span className="eco-radar__blip-pillar">{blip.pillar}</span>
              <span className="eco-radar__blip-value">{blip.value}</span>
            </span>
          </div>
        );
      })}
    </div>
  );
}
